import { toast } from "sonner";
import { Copy, MessageCircle, Send, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Bloque de compartir un link corto (guía o formulario). Reutilizado desde
 * GuideDetailSheet y LeadDetailSheet -- Twilio no está conectado todavía
 * (ver modules/messaging/ports.py), así que la vía es copiar/compartir a
 * mano por WhatsApp o SMS. */
export function ShareLinkBlock({ share, message }) {
  if (!share) return null;
  const text = encodeURIComponent(message || `Here's the guide you asked about: ${share.short_url}`);
  const phoneDigits = (share.recipient_phone || "").replace(/[^\d+]/g, "");

  const copy = () => {
    navigator.clipboard.writeText(share.short_url);
    toast.success("Link copiado");
  };

  return (
    <div className="space-y-2 border border-[#E4E4E7] rounded-md p-3 bg-[#FAFAFA]" data-testid="share-link-block">
      {share.is_temporary_domain && (
        <div className="flex items-start gap-2 text-xs text-[#92400E] bg-[#F59E0B]/10 rounded-sm p-2" data-testid="share-temporary-domain-warning">
          <AlertTriangle className="h-3.5 w-3.5 shrink-0 mt-0.5" />
          <span>Dominio temporal: este link va a dejar de funcionar cuando se migre al dominio final.</span>
        </div>
      )}
      <p className="text-xs font-mono break-all text-[#71717A]" data-testid="share-link-url">{share.short_url}</p>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant="outline" className="rounded-md" onClick={copy} data-testid="share-copy-button">
          <Copy className="h-3.5 w-3.5 mr-1" /> Copiar link
        </Button>
        {phoneDigits && (
          <>
            <a href={`https://wa.me/${phoneDigits.replace("+", "")}?text=${text}`} target="_blank" rel="noreferrer" data-testid="share-whatsapp-link">
              <Button size="sm" variant="outline" className="rounded-md text-[#10B981] border-[#10B981]/30">
                <MessageCircle className="h-3.5 w-3.5 mr-1" /> WhatsApp
              </Button>
            </a>
            <a href={`sms:${phoneDigits}?body=${text}`} data-testid="share-sms-link">
              <Button size="sm" variant="outline" className="rounded-md">
                <Send className="h-3.5 w-3.5 mr-1" /> SMS
              </Button>
            </a>
          </>
        )}
      </div>
      {!phoneDigits && (
        <p className="text-xs text-[#A1A1AA]">Sin teléfono de destinatario: copiá el link y compartilo a mano.</p>
      )}
    </div>
  );
}
